import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'forgot-password.container',
    templateUrl: './forgot-password.container.component.html',
    imports: [
        
    ]
})

export class ForgotPassworContainerComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}